import { useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { homePath, isValidLang, DEFAULT_LANG } from '../seo/seoConfig';

export const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: 'smooth' });
};

// Scrolls to a homepage section, navigating home first when on another route
export const useSectionNav = () => {
  const { i18n } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();
  const lang = (i18n.language || DEFAULT_LANG).slice(0, 2);
  const home = homePath(isValidLang(lang) ? lang : DEFAULT_LANG);

  return useCallback((id) => {
    if (location.pathname === home || location.pathname === `${home}/`) {
      scrollToId(id);
    } else {
      navigate(`${home}#${id}`);
    }
  }, [location.pathname, home, navigate]);
};
